import ApiService from "@services/api.service";
import {Notify} from 'quasar';

export const etudiantEvaluationPedagogique = {
  state: {
    evaluationsPeda: [],
  },
  mutations: {
    setEvaluationsPeda (state, evaluationsPeda) {
      state.evaluationsPeda = evaluationsPeda;
    }
  },
  actions:{
    async fetchEvaluationPedagogiqueEtudiant(context, etudiant){
      try{
        const response = await ApiService.getRequest(`evaluation_pedagogique/${etudiant}`)
        context.commit('setEvaluationsPeda', response.data)
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    }
  },
  getters: {
    getEvaluationsPeda (state) {
     return state.evaluationsPeda;
    }
  }
}
